import { RadioGroupField } from 'lib/iterable-hook-form';
import {
  FirebaseNotificationType,
  IntegrationFormField,
} from 'modules/mobileApps/context/integrationForm';
import { ToggleRow } from '../ApnsIntegrationForm.styled';
import { NotificationTypeFieldWrapper, SecondaryText } from '../FirebaseIntegrationForm.styled';

const FIREBASE_RADIO_OPTIONS = [
  {
    id: 'notification-messages',
    label: 'Notification messages',
    description:
      'Use when you want the FCM SDK to handle displaying a notification automatically when your app is running in the background.',
    value: FirebaseNotificationType.NOTIFICATION,
  },
  {
    id: 'data-notifications',
    label: (
      <>
        Data notifications <SecondaryText>(Required For Iterable SDK)</SecondaryText>
      </>
    ),
    description: 'Use when you want to process the messages with your own client app code.',
    value: FirebaseNotificationType.DATA,
  },
];

export const NotificationTypeField = ({ ...props }) => {
  return (
    <NotificationTypeFieldWrapper
      labelText="Firebase Cloud Messaging (FCM) type"
      descriptionText="Determine what type of message you want to send to end-user devices via this app."
      {...props}
    >
      <ToggleRow>
        <RadioGroupField
          name={IntegrationFormField.firebaseNotificationType}
          options={FIREBASE_RADIO_OPTIONS}
        />
      </ToggleRow>
    </NotificationTypeFieldWrapper>
  );
};
